// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".poweredBy-sh-tag {\n    display: none;\n}\n\n@media print {\n    .poweredBy-sh-tag {\n        width: 100%;\n        display: flex;\n        color: #212121;\n    }\n}", ""]);
// Exports
module.exports = exports;
